import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/Vehicles/";

export function getVehicle(ClientId, UserId) {
  return apiUtils
    .get(`${baseUrl}GetClientVehicles/?ClientID=${ClientId}&UserID=${UserId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateVehicle(params) {
  return apiUtils
    .put(`${baseUrl}UpdateClientVehicle`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function saveVehicle(params) {
  return apiUtils
    .post(`${baseUrl}`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getVehicleData(LPState, LPNumber, LPCountry) {
  return apiUtils
    .post(
      `${baseUrl}GetCarsXEData?LPNumber=${LPNumber}&LPState=${LPState}&Country=${LPCountry}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getVehicleModels(VehicleMakeId) {
  return apiUtils
    .get(`${baseUrl}GetModel/${VehicleMakeId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getVehicleMakes() {
  return apiUtils
    .get(`${baseUrl}Make`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getVehicleTrim(vehicleModel) {
  return apiUtils
    .get(`${baseUrl}model/${vehicleModel}/trims`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
